import {AfterViewInit, Component, OnInit} from '@angular/core';
import {CustomDashboardsService} from "app/modules/my-limegear/services/my-limegear.service";
import {ECloseService, IECloseCardInfo} from "app/modules/production/services/eClose.service";
import {NoDataActionType} from "app/modules/shared/interfaces/no-data";

@Component({
  selector: 'est-savings-by-method-lgc',
  templateUrl: './est-savings-by-method-lgc.component.html',
  styleUrls: ['./est-savings-by-method-lgc.component.scss']
})
export class EstSavingsByMethodLgcComponent implements OnInit, AfterViewInit {

  constructor(
      private _customDashboardsService: CustomDashboardsService,
      private _eCloseService: ECloseService,

  ) {
  }

  action: NoDataActionType;
  chartCardInfo: IECloseCardInfo;

  ngOnInit() {
    this.action = NoDataActionType.pageStart;
    this.chartCardInfo = {
      title: 'Estimated Savings by eClose Method',
      uniqueId: 'insights_estimatedSavingByECloseMethod',
      cardId: 'insights_estimatedSavingByECloseMethod',
      isSackChart: false,
      chartType: 'bar',
      yProperty: 'revenue',
      xProperty: 'category',
      seriesProperty: 'category',
      yTitle: 'Estimated Savings ($)',
      showLegend: false,
      showTotalAt: null,
      showDataLabels: true,
      tooltipTitleSuffix: 'Savings by eClose Method',
      formatMonthLabel: false,
      showMainValueToRight: false,
      module: 'Production',
    };

    this._eCloseService.initializeECloseCard(
        this.chartCardInfo,
        this.action,
    );
  }

  ngAfterViewInit() {
    this._customDashboardsService.filterChangesSubject$.subscribe((changes) => {
      this._eCloseService.updateCard(
          this.chartCardInfo,
          changes.displayOptions,
          changes.hierarchyfilters,
          changes.action,
      );
    });
  }
}
